export const SAVE = '@menu/SAVE';
export const UPDATE = '@menu/UPDATE';
export const REMOVE = '@menu/REMOVE';
